import React, { CSSProperties } from 'react';

interface AutoPlayVideoProps {
  mp4Src: string;
  webmSrc: string;
  alt: string;
  style?: CSSProperties;
  className?: string;
}

export const AutoPlayVideo: React.FC<AutoPlayVideoProps> = ({
  mp4Src,
  webmSrc,
  alt,
  style,
  className
}) => {
  return (
    <video
      autoPlay
      loop
      muted
      playsInline
      style={style}
      className={className}
      aria-label={alt}
    >
      <source src={webmSrc} type="video/webm" />
      <source src={mp4Src} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};
